import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage, FormikHelpers } from "formik";
import { ReactComponent as LeftArrow } from "../../resources/icons/left_arrow.svg";
import CustomSelect from "../elements/CustomSelect";
import Modal from "../elements/Modal";
import successIcon from "../../resources/icons/success.svg";
import { CREATE_USER_VALIDATION } from "../forms/Validations";

const AdminCreateUser = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [createdUserName, setCreatedUserName] = useState("");

  const initialValues = {
    name: "",
    role: "",
    email: "",
    phone: "",
    password: "",
  };

  const onSubmit = async (
    values: any,
    { resetForm, setSubmitting, setFieldError }: FormikHelpers<any>
  ) => {
    try {
      const token = localStorage.getItem("token");

      const payload = {
        email: values.email,
        password: values.password,
        name: values.name,
        phone: values.phone,
        type: values.role.toUpperCase().replace(" ", "_"),
      };

      const res = await fetch(`${process.env.REACT_APP_URL}/admin/users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) {
        if (data.error?.includes("email")) {
          setFieldError("email", data.error);
        } else {
          alert(data.error || "Something went wrong.");
        }
        return;
      }

      setCreatedUserName(data.name);
      resetForm();
      setIsModalOpen(true);
    } catch {
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex flex-row flex-1">
        <div className="flex-1 ml-[17.5rem] flex flex-col ">
          <div className="flex flex-row pl-6 pt-6  border-b">
            <button
              onClick={() => navigate("/admin/management")}
              className="flex items-center font-bold mb-4"
            >
              <LeftArrow className="w-6 h-6" style={{ color: "#344054" }} />
            </button>
            <h1 className="text-[#344054] font-inter font-bold text-[24px] leading-[100%] tracking-[0%]">
              Create User
            </h1>
          </div>

          <Formik
            initialValues={initialValues}
            validationSchema={CREATE_USER_VALIDATION}
            onSubmit={onSubmit}
          >
            {({ resetForm, isValid, values }) => (
              <Form className="w-full flex-1 flex flex-col justify-between">
                <div>
                  <div className="mb-4 w-[23rem] pl-6 mt-4">
                    <label htmlFor="name" className="block ">
                      Name
                    </label>
                    <Field
                      type="text"
                      id="name"
                      name="name"
                      placeholder="User name"
                      className="border  rounded p-2 w-full  text-[#101828] placeholder-[#667085]"
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="text-red-500 text-sm"
                    />
                  </div>
                  <div className="mb-4 w-[23rem] pl-6">
                    <label htmlFor="role" className="block ">
                      Role
                    </label>
                    <CustomSelect name="role" />
                    <ErrorMessage
                      name="role"
                      component="div"
                      className="text-red-500 text-sm"
                    />
                  </div>

                  <div className="mb-4 w-[23rem] pl-6">
                    <label htmlFor="email" className="block ">
                      Email
                    </label>
                    <Field
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Enter user email"
                      className="border rounded p-2 w-full text-[#101828] placeholder-[#667085]"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-red-500 text-sm"
                    />
                  </div>

                  <div className="mb-4 w-[23rem] pl-6">
                    <label htmlFor="phone" className="block ">
                      Phone Number
                    </label>
                    <Field name="phone">
                      {({ field, form }: any) => (
                        <input
                          {...field}
                          id="phone"
                          type="text"
                          placeholder="Enter user phone number"
                          className="border rounded p-2 w-full text-[#101828] placeholder-[#667085]"
                          onChange={(e) => {
                            const noSpaces = e.target.value.replace(/\s+/g, "");
                            form.setFieldValue("phone", noSpaces);
                          }}
                        />
                      )}
                    </Field>
                    <ErrorMessage
                      name="phone"
                      component="div"
                      className="text-red-500 text-sm"
                    />
                  </div>

                  <div className="mb-4 w-[23rem] pl-6">
                    <label htmlFor="password" className="block ">
                      Password
                    </label>
                    <Field
                      type="password"
                      id="password"
                      name="password"
                      placeholder="Set user password"
                      className="border rounded p-2 w-full"
                    />
                    <ErrorMessage
                      name="password"
                      component="div"
                      className="text-red-500 text-sm"
                    />
                  </div>
                </div>

                <div className=" flex justify-start gap-4  mt-auto border-t pl-6 py-4">
                  <button
                    type="button"
                    onClick={() => {
                      resetForm();

                      if (location.key) {
                        navigate(-1);
                      } else {
                        navigate("/admin/management");
                      }
                    }}
                    className="px-4 py-2 bg-white  border rounded-md font-semibold"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 rounded transition-colors"
                    disabled={
                      !isValid ||
                      !Object.values(values).every((val) => val !== "")
                    }
                    style={{
                      backgroundColor: "#1672EC",
                      color: "white",
                      opacity:
                        !isValid ||
                        !Object.values(values).every((val) => val !== "")
                          ? 0.5
                          : 1,
                      cursor:
                        !isValid ||
                        !Object.values(values).every((val) => val !== "")
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    Create User
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <Modal isOpen={isModalOpen} maxWidth="32rem">
        <div className="flex flex-col ">
          <div className="w-12 h-12 bg-[#DCFAE6] rounded-full flex items-center justify-center mx-4 my-4">
            <img src={successIcon} alt="Success" className="w-5 h-5" />
          </div>
          <h2 className="text-xl font-bold  mx-4 my-2">User created!</h2>
          <p className="text-gray-600 border-b pb-4 mx-4 ">
            You’ve successfully created the account of
            <span className="font-semibold mx-2"> {createdUserName}.</span>
          </p>
          <button
            onClick={() => navigate("/admin/management")}
            className="px-4 py-2 mx-4 my-6 bg-buttonBlue text-white rounded-md font-semibold"
          >
            Go to User Management
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default AdminCreateUser;
